import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {rgbToAlfa} from '../../../selectors/UtilSelectors';

const TagProps = {
    id: PropTypes.number,
    name: PropTypes.string.isRequired,
    categoryName: PropTypes.string,
    count: PropTypes.number,
    clearTag: PropTypes.func.isRequired,
    color: PropTypes.string
};

const Tag = ({ id, name, categoryName, count, clearTag, personId, color }) => {
    const onClick = () => categoryName && id ?
        clearTag(categoryName, id) :
        clearTag();

    const tagStyle = {
        color: `var(--page-main-color, ${color})`,
        backgroundColor: `var(--page-main-color-opacity-10, ${rgbToAlfa(color, 0.15)})`,
        borderColor: `var(--page-main-color-opacity-40, ${color})`
    };

    return (
        <div className="selected-tags-tag" style={tagStyle}>
            <div className="selected-tags-tag-label">
                {personId ?
                    <Fragment>Speaker: <strong>{name}</strong></Fragment> :
                    <Fragment>{name} {count !== undefined && ` (${count})`}</Fragment>
                }
            </div>
            <div className="selected-tags-tag-clear margin-left-xs custom" onClick={onClick}>
                <i className="fa fa-times" />
            </div>
        </div>
    );
};

Tag.propTypes = TagProps;

const SelectedTagsProps = {
    tags: PropTypes.arrayOf(PropTypes.shape(TagProps)),
    clearAllTags: PropTypes.func.isRequired,
    color: PropTypes.string
};

const SelectedTags = ({ tags, clearAllTags, color }) => (
    <div className="selected-tags">
        <div className="selected-tags-wrapper">
            {tags.map((tag, index) => <Tag key={index} {...tag} color={color} />)}
        </div>
        <div className="selected-tags-clear custom-color color-1" onClick={() => clearAllTags()}>Clear All</div>
    </div>
);

SelectedTags.propTypes = SelectedTagsProps;

export default SelectedTags;
